import {Box, Button, Card, Dialog} from "@mui/material";
import {CMItems} from "../../../core/utils/constants";
import React, { useEffect, useState } from "react"
import {DataGridPro} from "@mui/x-data-grid-pro";
import CmChargeBlock from "../../Charger/cm/cmChargeBlock";

const columns = [
    {field: 'name', headerName: 'Name', hide: false, width: 700},
    {field: 'data', headerName: 'Data', hide: false, width: 700},
]

export default function CollectionItems({items}) {
    const [rows, setRows] = useState([])
    const [selectedRows, setSelectedRows] = useState([]);
    const disable = selectedRows.length === 0

    const [chargeItemsDialog, setChargeItemsDialog] = useState(false);

    useEffect(() => {
        setRows(
            Object.entries(items).map((([key, value]) => (
                {
                    id: value.Id,
                    data: value.Count,
                    type: "items",
                    category: "Collections",
                    name: CMItems.Collections[value.Id] !== undefined ? CMItems.Collections[value.Id] : value.Id,
                })))
        )
    }, [items])

    const handleSelectRows = (ids) => {
        const selectedIDs = new Set(ids);
        const selectedRowData = rows.filter((row) =>
            selectedIDs.has(row.id.toString()));
        setSelectedRows(selectedRowData);
    }

    return (
        // <Card>
        //     <Table>
        //         <TableBody>
        //             {rows.map((row) => (
        //                 <TableRow>
        //                     <TableCell>{row.id}</TableCell>
        //                     <TableCell>{row.count}</TableCell>
        //                 </TableRow>
        //             ))}
        //         </TableBody>
        //     </Table>
        // </Card>
        <Card>
            {/*<Button*/}
            {/*    disabled={disable}*/}
            {/*    variant={'contained'}*/}
            {/*    color={"success"}*/}
            {/*    onClick={() => setChargeItemsDialog(!chargeItemsDialog)}>*/}
            {/*    Charge items*/}
            {/*</Button>*/}
            <Box sx={{width: '100%', height: 600}}>
                <DataGridPro
                    checkboxSelection={true}
                    onSelectionModelChange={(ids) => handleSelectRows(ids)}
                    columns={columns}
                    rows={rows}>
                </DataGridPro>
            </Box>
            <Dialog open={chargeItemsDialog} fullWidth={true}>
                <CmChargeBlock
                    massCharge={false}
                    initialSelectedItems={selectedRows}
                />

                <Button
                    disabled={disable}
                    variant={'contained'}
                    color={"success"}
                    onClick={() => setChargeItemsDialog(!chargeItemsDialog)}>
                    Cancel
                </Button>

            </Dialog>
        </Card>
    );
}
